import React from 'react'
import { Link } from 'gatsby'
import formatDate from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import { Columns, Column } from 'react-flex-columns'
import Heading from 'shared/ui/Heading'
import Tiles from 'shared/ui/Tiles'
import team from '../../data/team'
import { TagList } from '../../ui/Tags'
import BlogThumbImage from './BlogThumbImage'
import VisuallyHidden from '@reach/visually-hidden'

function BlogListings({ posts }) {
  return (
    <div className="spacing-large">
      <Tiles minSize={20}>
        {posts.map((post) => {
          const { id, title, author: teamId, date, tags, slug } = post
          const author = team.find((t) => t.id === teamId)
          const parsedDate = parseISO(date)
          const readableDate = formatDate(parsedDate, 'MMM do, yyyy')
          const dateTimeStamp = parsedDate.toISOString()
          const readingTime = getReadingTime(post)

          return (
            <article
              key={id}
              itemScope
              itemType="http://schema.org/BlogPosting"
              className="blog-index-item spacing-small"
            >
              <Columns className="blog-index-item" gutters>
                <Column>
                  <BlogThumbImage slug={slug} alt="" itemProp="image" />
                </Column>
                <Column flex className="spacing-xsmall">
                  <header>
                    <Heading itemProp="headline" as="h2" size={3}>
                      <Link to={`/blog/${slug}/`} className="title">
                        {title}
                      </Link>
                    </Heading>
                    <div className="text-xsmall">
                      <span>
                        By{' '}
                        <span itemProp="author" itemScope="" itemType="https://schema.org/Person">
                          {author.name}
                        </span>
                      </span>
                      <span aria-hidden>{' - '}</span>
                      <time itemProp="dateCreated pubdate datePublished" dateTime={dateTimeStamp}>
                        {readableDate}
                      </time>
                    </div>
                    {readingTime && (
                      <div className="text-xsmall">
                        <span itemProp="timeRequired">{readingTime}</span>
                      </div>
                    )}
                  </header>
                </Column>
              </Columns>
              <p className="text-small">{post.excerpt}</p>
              {Array.isArray(tags) && tags.length > 0 ? (
                <footer>
                  <span>
                    <VisuallyHidden>Tags: </VisuallyHidden>
                    <TagList tags={tags} />
                  </span>
                </footer>
              ) : null}
              <hr aria-hidden />
            </article>
          )
        })}
      </Tiles>
    </div>
  )
}

export default BlogListings

function getReadingTime(post) {
  if (!post.readingTime) {
    return null
  }

  let minutes = post.readingTime.minutesRounded
  let timeString = minutes < 1 ? 'Less than 1' : String(minutes)
  return timeString + ' minute read'
}
